import React from 'react';
import { View } from "../../Components/Themed";
import ProgressTimer from './ProgressTimer';
import type { PollProps } from '../../types';
import moment from 'moment-mini';

type MarketTimerProps = {
    poll:PollProps,
    onTimesUp:() => void
}

const MarketTimer = ({ poll, onTimesUp }:MarketTimerProps) => {
    
    let start = moment().subtract(1, 'hour');
    if(poll.start_datetime){ start = moment(poll.start_datetime) }
    let stop = moment(poll.end_datetime);

    let diff = stop.diff(start, 'seconds'); //Diff is going to be the Max value
    let current_value = stop.diff(moment(), 'seconds');

    //return (<></>)
    if(diff <= 0){ return <></> }
    if(current_value <= 0){ return <></> }
    return (
        <View>
            <ProgressTimer
                max_value={diff}
                current_value={current_value}
                increment_type={'seconds'}
                time_id={poll.poll_id}
                max_label={moment(poll.end_datetime).format('ddd hh:mm a')}
                onTimesUp={onTimesUp}
            />
        </View>
    )
}

export default MarketTimer